var styleDataHash = "5839b6e3";
const injectCss = () => {
  var css = `[dir] .O0C1j{margin-bottom:var(--ricos-toggle-button-margin-bottom,0);margin-top:var(--ricos-toggle-button-margin-top,0)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var toggle_button_default = {
  "root": "O0C1j"
};
export {
  toggle_button_default as default,
  injectCss
};
//# sourceMappingURL=toggle-button-scss.js.map
